// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3s8cK","colMaxWidth":"Table_colMaxWidth__BzqE-"};